import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b598bec8")

_pushScopeId("data-v-b598bec8")
const _hoisted_1 = {
  class: "container myorders",
  id: "myorders"
}
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = { class: "d-lg-flex" }
const _hoisted_4 = { class: "myorders-actions order-lg-1 col-lg-2 mb-lg-0 justify-content-center justify-content-lg-end" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-export fs-18" }, null, -1)
const _hoisted_6 = { class: "orders-search col-lg-4 mt-auto" }
const _hoisted_7 = { class: "search-button-wrapper pl-15" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_9 = { class: "orders-total-filter col-lg-6 mt-auto px-lg-2" }
const _hoisted_10 = {
  class: "orders-total order-lg-1",
  style: {"height":"48px"}
}
const _hoisted_11 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-filter fs-24 pl7" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "orders-filter-circle"
}
const _hoisted_14 = {
  key: 0,
  class: "mobile-grid"
}
const _hoisted_15 = { class: "header-line" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_17 = { class: "mobile-table-info-card" }
const _hoisted_18 = { class: "details-row" }
const _hoisted_19 = { class: "details-row" }
const _hoisted_20 = { class: "details-row" }
const _hoisted_21 = { class: "phone" }
const _hoisted_22 = { class: "details-row" }
const _hoisted_23 = { class: "details-row" }
const _hoisted_24 = {
  key: 1,
  class: "desktop-grid"
}
const _hoisted_25 = { class: "w100" }
const _hoisted_26 = {
  key: 0,
  class: "text-center"
}
const _hoisted_27 = { class: "thead-cell-center" }
const _hoisted_28 = { class: "desktop-table-action" }
const _hoisted_29 = { class: "thead-cell-end" }
const _hoisted_30 = { class: "desktop-table-text-setting" }
const _hoisted_31 = { class: "desktop-table-text-setting" }
const _hoisted_32 = { class: "desktop-table-text-setting" }
const _hoisted_33 = { class: "desktop-table-text-setting" }
const _hoisted_34 = { class: "cuted-cell" }
const _hoisted_35 = {
  class: "desktop-table-text-setting",
  style: {"padding-inline-start":"8px"}
}
const _hoisted_36 = { class: "cuted-cell" }
const _hoisted_37 = { class: "desktop-table-text-setting" }
const _hoisted_38 = { class: "desktop-table-text-setting" }
const _hoisted_39 = { class: "desktop-table-text-setting" }
const _hoisted_40 = { class: "desktop-table-text-setting" }
const _hoisted_41 = { class: "desktop-table-text-setting" }
const _hoisted_42 = { class: "desktop-table-text-setting" }
const _hoisted_43 = {
  key: 0,
  class: "text-center",
  style: {"position":"relative"}
}
const _hoisted_44 = { class: "warning-info-text" }
const _hoisted_45 = { class: "desktop-table-action text-center" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
const _hoisted_47 = { class: "orders-sticky-summary-wrapper" }
const _hoisted_48 = { class: "orders-sticky-summary" }
const _hoisted_49 = { class: "orders-total" }
const _hoisted_50 = { class: "orders-total" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "orders-total" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_OrderQtyReportModal = _resolveComponent("OrderQtyReportModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('navbar.myOrders')), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("button", {
            type: "button",
            class: "order-circle-btn circle-red mx-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.OrdersForToday()))
          }, _toDisplayString(_ctx.$t('orders.ordersForToday')), 1),
          _createVNode("button", {
            type: "button",
            class: "order-circle-btn circle-red mx-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.GetRQOrders()))
          }, _toDisplayString(_ctx.$t('orders.RQOrders')), 1),
          _createVNode("button", {
            type: "button",
            class: "d-none order-circle-btn new-order mx-1",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createNewOrder && _ctx.createNewOrder(...args)))
          }, _toDisplayString(_ctx.$t('button.newOrder')), 1),
          _createVNode("button", {
            type: "button",
            class: "order-circle-btn btn-green mx-1",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.exportOrders && _ctx.exportOrders(...args)))
          }, [
            _hoisted_5,
            _createVNode("div", null, _toDisplayString(_ctx.$t('report.export')), 1)
          ]),
          _createVNode("button", {
            type: "button",
            class: "order-circle-btn qty-report",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.qtyReport && _ctx.qtyReport(...args)))
          }, _toDisplayString(_ctx.$t('button.qtyReport')), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _withDirectives(_createVNode("input", {
            class: "bookit-input order-input w100",
            id: "datetime",
            type: "text",
            placeholder: _ctx.$t('placeholder.searchByEmailOrNumber'),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.keyword = $event))
          }, null, 8, ["placeholder"]), [
            [_vModelText, _ctx.filter.keyword]
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("button", {
              type: "button",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.getOrders && _ctx.getOrders(...args)))
            }, [
              _hoisted_8
            ])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", null, _toDisplayString(_ctx.$t('orders.totalOrders')) + ":", 1),
            _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('orders.ofOrders', { total: _ctx.total })), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("span", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
            }, _toDisplayString(_ctx.$t('button.showAll')), 1)
          ]),
          _createVNode("div", {
            class: ["orders-filter", { hasFilter: _ctx.hasFilter }]
          }, [
            _createVNode("button", {
              type: "button",
              class: "orders-filter-btn-text",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.ShowFilter && _ctx.ShowFilter(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('button.filters')) + " ", 1),
              _hoisted_12
            ]),
            (_ctx.hasFilter)
              ? (_openBlock(), _createBlock("div", _hoisted_13, "!"))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      (_ctx.isMobileView && _ctx.orders && _ctx.orders.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders, (row, index) => {
              return (_openBlock(), _createBlock("div", {
                onClick: ($event: any) => (_ctx.goToDetails(row.id)),
                class: "order-item",
                key: index
              }, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", null, _toDisplayString(row.orderNumber || 0), 1),
                  _createVNode("span", null, _toDisplayString(_ctx.formatAmount(row.total)) + " " + _toDisplayString(row.currencySymbol), 1),
                  _createVNode("span", {
                    style: { color: _ctx.OrderStatusColors[row.orderStatusId] }
                  }, _toDisplayString(row.orderStatusName), 5)
                ]),
                _hoisted_16,
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('orders.providerName')) + ": ", 1),
                    _createVNode("span", null, _toDisplayString(row.providerName), 1)
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('orders.product')) + ": ", 1),
                    _createVNode("span", null, _toDisplayString(row.productName), 1)
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('orders.phone')) + ": ", 1),
                    _createVNode("span", _hoisted_21, _toDisplayString(row.customerMobile), 1)
                  ]),
                  _createVNode("div", _hoisted_22, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('orders.arrival')) + ": ", 1),
                    _createVNode("span", null, _toDisplayString(_ctx.getOrderProductStartDate(row.orderProductStartDate)) + " - " + _toDisplayString(_ctx.removemillis(row.slotStartTime)) + " - " + _toDisplayString(_ctx.getHoursMinutes(row.durationMinutes)), 1)
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('duration.QTY')) + ": ", 1),
                    _createVNode("span", null, _toDisplayString(_ctx.displayCustomers(row.customers)), 1)
                  ])
                ])
              ], 8, ["onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMobileView)
        ? (_openBlock(), _createBlock("div", _hoisted_24, [
            _createVNode("table", _hoisted_25, [
              _createVNode("thead", null, [
                _createVNode("tr", null, [
                  _createVNode("td", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sotrBy('OrderNumber'))),
                    style: {"width":"8%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('orders.order')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('OrderNumber')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sotrBy('ProviderName'))),
                    style: {"width":"10%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('orders.providerName')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderName')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sotrBy('ProviderId'))),
                    style: {"width":"10%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('orders.providerId')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ProviderId')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sotrBy('Activity'))),
                    style: {"width":"12%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('orders.product')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Activity')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sotrBy('FullName'))),
                    style: {"width":"13.7%","padding-inline-start":"8px"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('label.customer_name')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('FullName')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sotrBy('ArrivalDate'))),
                    style: {"width":"8%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('newOrder.arrivalDate')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ArrivalDate')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.sotrBy('Total'))),
                    style: {"width":"8%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('newOrder.total')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Total')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sotrBy('Balance')))
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('orders.balance-title')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Balance')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.sotrBy('Channel'))),
                    style: {"width":"7%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('label.channel')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Channel')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.sotrBy('Quantity'))),
                    style: {"width":"5%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('product.QTY')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Quantity')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", {
                    onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.sotrBy('ReservationDate'))),
                    style: {"width":"8%"}
                  }, [
                    _createVNode("span", null, [
                      _createTextVNode(_toDisplayString(_ctx.$t('orders.reservationDate')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('ReservationDate')]
                      }, null, 2)
                    ])
                  ]),
                  (_ctx.isAnyOrderHasRemarks())
                    ? (_openBlock(), _createBlock("td", _hoisted_26, _toDisplayString(_ctx.$t('order.remarks')), 1))
                    : _createCommentVNode("", true),
                  _createVNode("td", {
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.sotrBy('Status'))),
                    style: {"width":"6%"}
                  }, [
                    _createVNode("span", _hoisted_27, [
                      _createTextVNode(_toDisplayString(_ctx.$t('title.status')) + " ", 1),
                      _createVNode("i", {
                        class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Status')]
                      }, null, 2)
                    ])
                  ]),
                  _createVNode("td", _hoisted_28, [
                    _createVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('customerType.actions')), 1)
                  ])
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders, (row, index) => {
                  return (_openBlock(), _createBlock("tr", { key: index }, [
                    _createVNode("td", _hoisted_30, [
                      _createVNode(_component_router_link, {
                        to: { name: 'order', params: { id: row.id } },
                        class: "text-link m-0"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(row.orderNumber), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("td", _hoisted_31, [
                      _createVNode(_component_router_link, {
                        to: { name: 'provider-view', params: { id: row.providerId } },
                        class: "text-link cuted-cell m-0"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(row.providerName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createVNode("td", _hoisted_32, _toDisplayString(row.providerId), 1),
                    _createVNode("td", _hoisted_33, [
                      _createVNode("span", _hoisted_34, _toDisplayString(row.productName), 1)
                    ]),
                    _createVNode("td", _hoisted_35, [
                      _createVNode("span", _hoisted_36, _toDisplayString(row.customerFullName), 1)
                    ]),
                    _createVNode("td", _hoisted_37, [
                      _createVNode("div", null, _toDisplayString(_ctx.getOrderProductStartDate(row.orderProductStartDate)), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.removemillis(row.slotStartTime)), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.getHoursMinutes(row.durationMinutes)), 1)
                    ]),
                    _createVNode("td", _hoisted_38, _toDisplayString(_ctx.formatAmount(row.total)) + " " + _toDisplayString(row.currencySymbol), 1),
                    _createVNode("td", _hoisted_39, _toDisplayString(_ctx.formatAmount(row.balance)) + " " + _toDisplayString(row.currencySymbol), 1),
                    _createVNode("td", _hoisted_40, _toDisplayString(row.channel), 1),
                    _createVNode("td", _hoisted_41, _toDisplayString(_ctx.displayCustomers(row.customers)), 1),
                    _createVNode("td", _hoisted_42, [
                      _createVNode("div", null, _toDisplayString(_ctx.formatDateIgnoreZone(row.createDate)), 1),
                      _createVNode("div", null, _toDisplayString(_ctx.formatTimeIgnoreZone(row.createDate.split('T')[1])), 1)
                    ]),
                    (_ctx.isAnyOrderHasRemarks())
                      ? (_openBlock(), _createBlock("td", _hoisted_43, [
                          _createVNode("div", {
                            class: "mandatory-warning-info dp-none",
                            id: 'order-remark-' + index
                          }, [
                            _createVNode("div", _hoisted_44, _toDisplayString(_ctx.$t('order.warnings.hasRemark')), 1)
                          ], 8, ["id"]),
                          (row.haveRemarks)
                            ? (_openBlock(), _createBlock("i", {
                                key: 0,
                                onMouseleave: ($event: any) => (_ctx.hideWarning(index)),
                                onMouseenter: ($event: any) => (_ctx.showWarning(index)),
                                class: "icon-f icon-remarks fs-24"
                              }, null, 40, ["onMouseleave", "onMouseenter"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("td", {
                      class: "desktop-table-text-setting text-center",
                      style: `color: ${_ctx.OrderStatusColors[row.orderStatusId]}`
                    }, _toDisplayString(row.orderStatusName), 5),
                    _createVNode("td", _hoisted_45, [
                      _createVNode(_component_router_link, {
                        to: { name: 'order', params: { id: row.id } },
                        class: "m-0"
                      }, {
                        default: _withId(() => [
                          _hoisted_46
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", null, _toDisplayString(_ctx.$t('orders.totalOrders')) + ": ", 1),
                  _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " " + _toDisplayString(_ctx.$t('orders.ofOrders', { total: _ctx.total })), 1)
                ]),
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", null, _toDisplayString(_ctx.$t('orders.revenue')) + ":", 1),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.revenueByCurrencies, (revenueByCurrency, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      _createVNode("span", null, [
                        _createTextVNode("  " + _toDisplayString(_ctx.formatAmount(revenueByCurrency.total)) + " " + _toDisplayString(_ctx.getCurrencySymbol(revenueByCurrency.currencyId)) + " ", 1),
                        (index != _ctx.revenueByCurrencies.length - 1)
                          ? (_openBlock(), _createBlock("span", _hoisted_51, " /"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode("div", _hoisted_52, [
                  _createVNode("div", null, _toDisplayString(_ctx.$t('orders.totalTickets')) + ": ", 1),
                  _createVNode("div", null, _toDisplayString(_ctx.totalTickets), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_OrderQtyReportModal, { ref: "modalQtyReport" }, null, 512)
  ], 64))
})